var map = {
	"./step1.webp": 212,
	"./step2.webp": 849,
	"./step3.webp": 6,
	"./step4.webp": 771,
	"./step5.webp": 864,
	"./step6.webp": 293,
	"./step7.webp": 426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 705;